import { render, staticRenderFns } from "./ConfiguracionAcceso.vue?vue&type=template&id=f3d9a4a0&scoped=true&"
import script from "./ConfiguracionAcceso.vue?vue&type=script&lang=js&"
export * from "./ConfiguracionAcceso.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracionAcceso.vue?vue&type=style&index=0&id=f3d9a4a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d9a4a0",
  null
  
)

export default component.exports